import { HostListener, Component } from '@angular/core';

import {
    NavController,
    ViewController,
    NavParams,
    LoadingController} from 'ionic-angular';
import { RodeoService } from '../../services/rodeo.service';

@Component({
    selector: 'page-draw-results',
    templateUrl: 'draw-results.html'
})
export class DrawResults {
    rodeoCount: number = 0;
    randomEntryPlacement: string = "0";
    randomPrefPlacement: string = "0";

    nextGenEntryPlacement: string = "0";
    nextGenPrefPlacement: string = "0";

    upraEntryPlacement: string = "0";
    upraPrefPlacement: string = "0";

    popoverActive: boolean;

    constructor(private nav : NavController, private rodeoService: RodeoService, private loadingController: LoadingController, private viewController : ViewController, navParams: NavParams) {
        let results = navParams.get('results')[0];

        if (results) {
            this.rodeoCount = (results as any).rodeosDrawn;
            this.randomEntryPlacement = '' + Math.round((results as any).randomEntryPlacement * 10) / 10;
            this.randomPrefPlacement = '' + Math.round((results as any).randomPrefPlacement * 10) / 10;

            this.nextGenEntryPlacement = '' + Math.round((results as any).nextGenEntryPlacement * 10) / 10;
            this.nextGenPrefPlacement = '' + Math.round((results as any).nextGenPrefPlacement * 10) / 10;

            this.upraEntryPlacement = '' + Math.round((results as any).upraEntryPlacement * 10) / 10;
            this.upraPrefPlacement = '' + Math.round((results as any).upraPrefPlacement * 10) / 10;
        }
    }

    undo() {
        if (this.popoverActive)
            return;

        this.popoverActive = true;
        let loader = this.loadingController.create({
            content: 'Undoing draw...',
        });

        loader.present();

        this.rodeoService.undoDraw()
        .then(() => {
            loader.dismiss();
            this.popoverActive = false;
        }).catch(() => {
            loader.dismiss();
            this.popoverActive = false;
        })
    }

    back() {
        this.nav.pop();
    }

    _bdClick() {
        return this.nav.pop();
    }

    @HostListener('body:keyup', ['$event'])
    _keyUp(ev: KeyboardEvent) {
        if (ev.keyCode === 27 && this.viewController.isLast()) {
            this._bdClick().catch((err) => {
                console.warn(err);
            });
        }
    }
}


// WEBPACK FOOTER //
// ./src/pages/rodeo/draw-results.ts